import React from "react";
import OfflineComponent from "components/General/OfflineComponent";
import { userRoles } from "../../settings/shared/constants";

class NetworkStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        document.body.classList.add("tenant-page");
        var elements = document.getElementsByClassName('full-page section-image');
        for (var index = 0; index < elements.length; index++) {
            elements[index].classList.add("df-bg-white");
        }
        this._checkIfOnline();
    }

    _checkIfOnline = () => {
        if (navigator.onLine) {
            if (localStorage.getItem("Uid") !== null) {
                if (localStorage.getItem("role") === userRoles.PLATFORM_ADMIN) {
                    let navigatePath = localStorage.getItem("lastPageHistory");
                    this.props.history.push(navigatePath);
                } else {
                    let navigatePath = localStorage.getItem("lastPageHistory");
                    this.props.history.push(navigatePath);
                }
            }else{
                this.props.history.push("/auth/login-page");
            }
        }
    }

    render() {
        return (
            <div className="content">
                <OfflineComponent
                    _checkIfOnline={this._checkIfOnline.bind(this)} />
            </div>
        )
    }
}

export default NetworkStatus;
